/**
 * VendorRouteRegistry — fallback menu used when /api/me/menu cannot be reached.
 */

export interface VendorRegisteredRoute {
  readonly path: string;
  readonly label: string;
  readonly section: string;
  readonly sortOrder: number;
}

export const VENDOR_ROUTE_REGISTRY: ReadonlyArray<VendorRegisteredRoute> = [
  { path: '/vendor/dashboard', label: 'Dashboard', section: 'OVERVIEW', sortOrder: 10 },
  { path: '/vendor/portal/inbox', label: 'Inbox', section: 'OVERVIEW', sortOrder: 20 },
  { path: '/vendor/portal/dashboard', label: 'Operations', section: 'OVERVIEW', sortOrder: 30 },

  { path: '/vendor/portal/painters', label: 'Painters', section: 'PAINTER', sortOrder: 10 },
  { path: '/vendor/portal/painters/new', label: 'Add Painter', section: 'PAINTER', sortOrder: 20 },

  { path: '/vendor/reviews/queue', label: 'Review Queue', section: 'QUALITY', sortOrder: 10 },

  { path: '/vendor/portal/billing/inbox', label: 'Billing Inbox', section: 'BILLING', sortOrder: 10 },
  { path: '/vendor/portal/billing/claims', label: 'My Bills', section: 'BILLING', sortOrder: 20 },
  { path: '/vendor/portal/billing/new', label: 'Raise Bill', section: 'BILLING', sortOrder: 30 },
  { path: '/vendor/portal/payments', label: 'Payments', section: 'BILLING', sortOrder: 40 },
  { path: '/vendor/portal/payment-advices', label: 'Payment Advices', section: 'BILLING', sortOrder: 50 },
];
